{
    "releaseVersion": "Release 25.4",
    "headers": [
        "General",
        "Messaging",
        "Gamification",
        "QA",
        "Dashboards",
        "Coaching",
        "Wallboards"
    ],
    "displayHeaders": [
        "General",
        "Messaging",
        "Gamification",
        "QA",
        "Dashboards",
        "Coaching",
        "Wallboards"
    ],
    "Notes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    },
    "DirectNotes": {
        "General": [],
        "Messaging": [],
        "Gamification": [],
        "Coaching": [],
        "QA": [],
        "Dashboards": [],
        "Wallboards": []
    },
    "NiceInContactNotes": {
        "General": [],
        "Messaging": [],
        "Gamification": [],
        "Coaching": [
            {
                "Description": "Conducted Date and Save As Draft Status:​",
                "Details": [
                    "Coaching package will be receiving a new functionality called \"Conducted Date\" which will give supervisors the ability to successfully document a coaching that may have happened in the past but forgot to document it accordingly.",
                    "A \"Save As Draft\" Status is also being incorporated to the Coaching package. Supervisors will be able to select it in case they would like to continue later. If a coaching is saved as draft, the agents will not be able to see it, and a conducted date will not be selectable.​"
                ]
            }
        ],
        "QA": [],
        "Dashboards": [
            {
                "Description": "Gauge Widget: Minimum and Maximum Value Editing​. We’ve introduced new customization options to improve the usability and flexibility of the Gauge Widget:​",
                "Details": [
                    "Users can now manually set minimum and maximum values for the gauge scale.​",
                    "Default values are based on the metric’s objective parameters but can be adjusted as needed.​",
                    "Shared dashboards retain and display the configured gauge settings for all viewers.",
                    "The new Min/Max Settings option is available from the widget’s 3-dots menu.​",
                    "A Reset to Default button allows users to quickly revert to original settings."
                ]
            },
            {
                "Description": "Custom Date Ranges on Metric​ Review Widget: An enhancement has been added to the Metric Review widget. In the past, the Metric Review Widget had the ability to select three fixed dates, and they couldn't be customized to any date. Now you'll be able to select three different dates for easier comparison:",
                "Details": [
                    "Users will see this functionality available on the widget settings.​​",
                    "Past dates and today are the only eligible dates for this.​",
                    "Date ranges that contain future dates will be capped up until today."
                ]
            },
            {
                "Description": "Gamification Stats Turned into Dashboard Metrics. A new set of metrics have been now created to be used in Dashboard widgets. These metrics come from Gamification Stats:​",
                "Details": [
                    "View real-time stats for active games, challenges, and orders.​​",
                    "Filter by agent, team, company, or custom groups.​",
                    "Helps track engagement, spot trends, and support coaching.",
                    "Enables data-driven decisions to boost motivation and results​.",
                    "Widgets Eligible for better visibility are Expanded Summary and Summary.",
                    "This feature is available upon modification request."
                ]
            }
        ],
        "Wallboards": []
    },
    "Five9Notes": {
        "General": [
        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    },
    "SerenovaNotes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    },
    "GenesysNotes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    },
    "CiscoNotes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    },
    "AmazonNotes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    },
    "AvayaNotes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [
        ]
    },
    "UJetNotes": {
        "General": [

        ],
        "Messaging": [

        ],
        "Gamification": [

        ],
        "Coaching": [

        ],
        "QA": [

        ],
        "Dashboards": [

        ],
        "Wallboards": [

        ]
    }
}
